module.exports = __webpack_public_path__ + "img/kuku.b6ba84ac.png";